// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { createAction } from 'typesafe-actions';
import { RunningLab } from '../../types/Model';

type UpdateRunningExamActionPayload = Partial<RunningLab>

export const updateRunningExamAction = createAction(
  'elearning/UPDATE_RUNNING_EXAM',
  (runningExam: UpdateRunningExamActionPayload) => (runningExam),
)<UpdateRunningExamActionPayload>();

export const clearRunningExamAction = createAction('elearning/CLEAR_RUNNING_EXAM')();
